/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_user" | "PdpRespTradeIconBubbles_user">;
    readonly " $refType": "PdpRespIconBubblesWrapper_user";
};
export type PdpRespIconBubblesWrapper_user$data = PdpRespIconBubblesWrapper_user;
export type PdpRespIconBubblesWrapper_user$key = {
    readonly " $data"?: PdpRespIconBubblesWrapper_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubblesWrapper_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubblesWrapper_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespTradeIconBubbles_user",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '19f3057534586ba1d5fd5bcf9624e8ef';
export default node;
